// import { get } from "lodash";

export default {
  getAdminLeadsList: (state) => state.adminLeads.adminLeadsList,
};
